module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("K")])]), _vm._v("eyed up and irked that he had to wait for oncoming traffic, Jake stopped the department’s white Jeep opposite Sarah’s house and waited for a battered red truck to go by. He was startled when the grizzled old man behind the wheel sent him a cold, hard look as he drove past.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have a nice day, too,” Jake muttered, wondering what he’d done to tick the man off already. Was the driver a fan of Comfort’s ousted ex-sheriff? Or had the official vehicle and Jake’s uniform made him wonder what Sarah had done to earn a visit from a lawman?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Easy answer, he thought, hitting the gas pedal and making a squealing left turn. She just might have given birth to his daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Much of her pink Victorian home was hidden from the road by a thick stand of pines. Jake’s heart leapt as he left them behind and moved up the steep, paved driveway. Sarah was just descending the porch steps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The instant she saw the car, her spine stiffened, and Jake knew their meeting wasn’t going to go well. But that knowledge didn’t prevent him from admiring her long tanned legs and cutoff denim shorts as she strode to the middle of the yard. A length of wide black plastic fluttered from her right hand, and a roll of silver duct tape circled her wrist, bracelet-style.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swore as he realized what she was about to do, then cut the engine, got out and quickly crossed the lawn. By the time he reached her, she’d already draped the plastic over her sign and was fighting the wind to secure it to the post.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why are you doing this?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why am I doing what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn, he hated it when people answered that way. He tried to count to ten—and made it to five. “If you’re closing because you don’t want to rent me a room, forget I even asked. I’m not going to make a big deal of your staying open. You have a child to support.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t need the income from the bed-and-breakfast to support Kylie,” she returned, ripping off another piece of tape and slapping it on her sign. “And my closing has nothing to do with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“After the talk I had with Maggie, that’s a little hard to believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah stopped moving, and her gaze widened accusingly. But there was hurt in her eyes, too. “You told Maggie about us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sighing, Jake shook his head, feeling bad that he’d put her on the defensive. But if she thought that giving him attitude would scare him off, she was wrong. “I don’t kiss and tell, Sarah. My conversation with Maggie concerned my finding a room to rent. When I told her you were closing, she was surprised. She said she’d spoken to you recently, and you hadn’t mentioned it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a cool look, she gathered the plastic together at the base of her sign, then ripped off another length of tape and wrapped it tightly. “I didn’t tell Maggie I’d just had my teeth cleaned, either, but that doesn’t mean it didn’t happen.” Sliding the roll of tape back on her arm, she stared at him through wind-tossed bangs. “Why is my closing or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" closing so important to you? We’re strangers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If we were strangers, my showing up here this morning wouldn’t have rattled you the way it did. You’re not doing much better now. Why is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why?” she repeated in an incredulous tone. “How can you even ask that question? Seeing you reminds me of something I did that I’m not very proud of, and I don’t want to be reminded of it. Maybe what happened between us was just another roll in the hay for you—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I told you it wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“—but I don’t sleep around.” Her white knit top had a scooped neckline, and her pulse hammered at the base of her throat. Inappropriate or not, Jake remembered kissing her there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The truth is,” she continued, “I’ve been thinking about closing for a while now. Your showing up just pushed my plans ahead a few months. I’m finding that I don’t have time to make meals and change sheets for guests anymore. My catering business is doing very well, and—and Kylie’s growing up fast. She deserves more time with me, and I need more time with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something in Jake softened. Whether she was his child or not, he was glad Sarah could work out of her home and give Kylie the attention and support she needed. He’d loved his mother, and in her way, he supposed Emily had loved him. But he’d always known he was third in line behind the current boyfriend and the next party. He hadn’t fared much better with the foster parents he’d stayed with after Emily had died. Kylie would never know that loneliness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The low hum of an engine drew Jake’s attention, and he turned to see a car come up the driveway, squeeze past his Jeep and continue on to the far side of the house. It stopped in the small parking area assigned to guests.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The color drained from Sarah’s face as an older man got out of the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re back, Mommy!” he called with a broad smile. “Safe and sound.” Then he opened the back door of his gray sedan and lifted Kylie out of her car seat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even as his heartbeat increased, Jake was startled to realize he’d been so involved with Sarah that he’d nearly forgotten Kylie was his main reason for coming back here. As she raced across the lawn to her mother, he fought to keep his features calm and controlled. Was Kylie his? Could she be?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, sweetheart,” Sarah said warmly, her voice shaking a little as she scooped her daughter into her arms. “Did you and Grandpa have a nice lunch at Aunt Ruby’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had ice cweam!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can see that,” Sarah replied. “It’s all over your shirt. We’ll have to change it before your nap.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry,” the older man said, chuckling as he walked to them. “I should’ve asked Ruby for a bib. And before you yell at me, she had macaroni and cheese before the ice cream—I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But more ice cream than macaroni, I’ll bet,” Sarah said, laughing. Her smile faded a little then, and after giving Jake a hesitant look, she put Kylie down. “Dad, this is Sheriff Russell. Sheriff, my father, Bill Malloy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice to meet you,” Jake said, and they clasped hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Same here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah’s father was a good-looking man in his late fifties, and aging well, despite the fair amount of gray in his dark hair and mustache. His choice of vehicles—a sedan—as well as his gray trousers and yellow knit shirt, suggested that he didn’t ranch or farm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what do you think of our little town, Sheriff?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I like it. Hope I have the chance to stay for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re talking about the November election,” Malloy guessed. “Well, just don’t tick off Ed Cooper at the paper or any of our local busybodies in the next couple of months, and you shouldn’t have a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks for the advice,” he answered, thinking about the old man in the red truck. “But it’s hard to know what annoys people until you get to know them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In this town, it could be anything,” Malloy returned wryly. “No matter what you do, you’re bound to rub someone the wrong way.” His devoted gaze fell to Kylie. “Except for Kylie, here. She loves everybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Malloy’s statement seemed to invite a conversation with his pretty little granddaughter, and Jake crouched down and smiled. She wore black shorts and a gray knit shirt with black sleeves and Mickey Mouse ears stitched to the hood hanging against her back. Or maybe they were Minnie Mouse ears. Suddenly everything this tiny girl wore, every move she made, every silky black hair above her blue eyes and animated baby face were vitally important to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, honey,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lightning quick, Kylie speared his badge with her index finger. “That’s a star!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake’s heart took off running, and he wondered how he’d lived this long without feeling this many emotions at once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah tugged Kylie back against her legs. “I’m sorry,” she said hurriedly. “She gets rambunctious when she has too much sugar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, no, she’s fine,” Jake said, pushing to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s go to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" house and pway!” Kylie piped up, and Jake wasn’t sure what to say. For starters, he didn’t have a house. But, by God, if Kylie was his, he’d find one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dad?” Sarah said, looking pale again. “Why don’t you take Kylie inside? I’ll be right in to change her shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a second, Malloy stared curiously at his daughter. Then he shrugged, grinned and scooped Kylie into his arms. “Sure. We’ll have a cup of coffee while we wait, won’t we, cupcake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dad—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” he said, chuckling. “We’ll have milk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they’d disappeared inside, Sarah mustered a wobbly grin and sighed. “He spoils her rotten.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He probably can’t help himself. She’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you.” Sarah glanced toward the door, a troubled look still clouding her eyes. “I’d better go. Dad can’t say no to her, and if he’s drinking coffee, she’s stealing sips. Between the sugar and the caffeine…well, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Jake wasn’t thinking of sugar and caffeine; he was studying Sarah’s classic features again—her wide brown eyes and lightly tanned skin. Her sideswept bangs and shoulder-length blond hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He realized that his suspicions were still only that. But none of Sarah’s coloring had shown up in her daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("None of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly, every warning he’d given himself about taking his time and gaining her confidence deserted him. He had to know. His chest was on fire, and he had to know.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does her other grandfather spoil her, too?” he asked as she turned toward the house.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He fell into step beside her. “You said your father spoils her. I asked if her other—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, her other Grandpa passed away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And by that, you mean your ex-husband’s father?” he persisted. Or did she mean "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" father? He’d told her that night that his dad had died before Jake had a chance to meet him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah moved faster through the grass. “My late husband’s father passed away, yes. Now, if you’ll excuse me, I need to change my daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, dammit, he wouldn’t excuse her. He’d come here looking for answers, and he wasn’t leaving until he got them. Kylie waved from the screen door, and a small voice cautioned, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t press your luck.")]), _vm._v(" But he couldn’t listen. Just one question. Maybe two.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How old is she, Sarah?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She started up the steps. “She’s two.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When will she be three?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the porch now, Sarah whirled on him, her dark eyes full of fire and fear. But was she afraid because a lingering conversation might tip her father off that they had a past, or because she was keeping a secret she didn’t want Jake to know?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What is this?” she asked in a low, shaky voice. “An occupational hazard? Do you interrogate everyone you meet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake raised his hands and backed off. He’d pushed too hard. If Kylie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" his daughter, he didn’t want to antagonize Sarah, because he wanted to be part of her life. If she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wasn’t,")]), _vm._v(" he didn’t want to look like a fool. He’d already shared too much of himself with this woman, and the last thing he wanted was to look weak in her eyes. Though why he cared, he didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The radio in the Jeep squawked loudly, and a distorted voice hailed him. Jake sent a frustrated look at the car. “No, I don’t interrogate everyone I meet. I’m sorry if I gave you that impression. I’d just like for us to be friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The radio squawked again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please…” he said, sidling away. “Just give me a minute to answer that, then we can finish talking. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But by the time he’d reached through the window, grabbed the mike and looked up again, Sarah was gone and both front doors were closed. “Yeah, Maggie,” he said through a sigh. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A cattle theft, that’s what was up. Two auction-ready steers were missing from the Wilson ranch. Jake drove out there and checked the cut fence line, then listened to Hap Wilson’s diatribe about shooting first and asking questions later if he found anyone near his stock again. Then Jake returned to the office without a shred of evidence, knowing that chances were, the people who’d taken Wilson’s cattle would never be found—not unless they made a habit of it and got sloppy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was close to five-thirty when Jake parked the Jeep in Sarah’s driveway again and got out. Three visits in one day made him feel more like a stalker than a man trying to get at the truth, but he couldn’t help himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Until this afternoon, all he’d had were suppositions. Now he had more. It wasn’t the most commendable thing he’d ever done, but a trip to the courthouse had told him that Kylie had been born on April 18.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("April was nine months from July and the Founder’s Day celebration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quickly ascending the steps to the wraparound porch, Jake rang the bell, waited a moment, then jabbed it again. He could hear it chime inside the house, but there were no footsteps on their way to him, no high-pitched baby giggles and running feet. Still, he had a strong feeling that Sarah was inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a second, he considered checking the garage in the back to see if her car was there. But he knew if Sarah saw him do it, it would make her even more wary and defensive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rang the bell again. And once more, all he got for his trouble was silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frustrated, Jake pulled a hand over his face, then yanked off the Stetson that matched his uniform and tugged it back on. All right, he thought, descending the steps again. She’d won this round. But she couldn’t avoid him forever.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jus’ whisper?” Kylie murmured again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah nodded and kept her voice low. “Yes, baby, this is a funny game. We just whisper.” She was holding Kylie again and trying to keep her still, two rooms away from the long panes of glass fronting the porch. Sarah peered through the dining room’s slightly open French doors, into the parlor and finally through the lace shades and curtains. She exhaled in relief when the white Jeep did a two-point turn in her driveway, coasted down to the road and disappeared. Thank heaven she’d seen him pull in and had time to shut off the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Three visits in one day?")]), _vm._v(" She didn’t know how, but somehow, Jake suspected that Kylie was his child. That second visit he’d paid on them had had nothing to do with his wanting them to be friends. Worse, his showing up here had drawn curious looks from her father, and she wasn’t ready to make explanations to him yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, sweetie,” she murmured. “What are we going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Feathery eyebrows dipped as Kylie seemed to consider her answer for a moment. Then she ventured, “Have cake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the conflicting feelings of fear and attraction that still shivered through her, Sarah had to smile. “Good idea. We could both use some chocolate. But let’s have supper first.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only one person knew that Kylie’s father was a deputy sheriff from one of Montana’s northern counties—Sarah herself. She hadn’t even told her parents because she’d feared they’d track him down and demand that he “do the right thing.” Now, two nerve-racking days after Jake’s last visit, she was about to add another name to the list.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bell over the door jangled as Sarah carried Kylie and a small tote bag full of toys into the noise and bustle of Aunt Ruby’s Café. As usual, the restaurant rang with country music, clanking silverware and the buzz of lunch-time diners. Sarah scanned the crowded tables and bright red booths, then moved forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ruby Cayhill hadn’t been hard to spot. The elderly proprietress was the only person in the café under five feet, over seventy-five and wearing red high-top sneakers. The red cardigan topping her white uniform dress flapped around her skinny frame as she approached them. Though the tiny woman insisted that everyone call her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aunt")]), _vm._v(" Ruby, her only blood kin were the Dalton brothers who owned the Brokenstraw Ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Afternoon, Sarah,” she sang out, carrying two empty coffeepots toward the lunch counter. She grinned at Kylie. “Hi there, sweet pea. You look like a gal who’d like some French fries.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah managed a smile. “She sure would. It’s all she’s talked about since I told her where we were headed.” Falling into step with Ruby, Sarah glanced down at the hairnet capping the woman’s frizz of gray curls. “So how’s business?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine as frog hair.” Ruby cackled. Pale blue eyes twinkled behind her wire-rimmed spectacles. “Cash register’s been ringin’ since sunup.” Moving behind the counter, she rinsed the empty pots, then rigged the coffeemakers with fresh grounds and water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How’s everything on yer end of town?” she called over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah sat on one of the red vinyl stools, then settled Kylie on her lap. “Not as fine as frog hair, but things are coming along.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Heard you shut down the bed-and-breakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah smiled wryly. Why was she not surprised that Ruby already knew? “Who told you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who didn’t?” Ruby harrumphed. “You know this town better’n most.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, she did. Marrying Vince had made her the target of gossips for years. Kylie’s birth had given them even more to talk about. Sarah glanced around the room where rotating ceiling fans cooled too many customers who might overhear. “Actually,” she said, softening her voice, “that’s what I’d like to talk about. When you have time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ruby paused for an instant, then clicked on the coffee-makers and turned from her task. “Got time right now. Will you be wantin’ lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah shook her head. “Just French fries and apple juice for Kylie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Motioning for Sarah to follow, Ruby grabbed a booster seat and strode to a back booth, calling the order to one of her waitresses. “And bring us two cups of regular,” she added.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But once there, Sarah put Kylie in the booth with her toys, and she and Ruby took seats at the adjacent table. Sarah didn’t want Kylie overhearing their conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Kylie was engrossed in her French fries and happily humming along to the nursery rhymes coming from her “boom box,” Sarah met Ruby’s gaze over their coffee cups.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some days, Ruby Cayhill was as no-nonsense and brittle as a pan of rock candy. But she had one of the warmest hearts and truest stares Sarah had ever known. She’d always been a good friend. Since her mother’s death, Sarah had come to depend on Ruby’s counsel even more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, Aunt Ruby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ain’t done nothin’ yet, honey. What’s the trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah drew a fortifying breath. Whoever said that confession was good for the soul had exaggerated badly. “It’s the new sheriff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The sheriff?” Ruby chuckled, and her pale eyes lit with mischief. “From what I’ve seen, he’s no trouble a-tall. Takes all his meals here, and the women can’t keep their eyes off him. That young fella’s been dang good fer business.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Has…has he been in today?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not thirty minutes ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Good. Then he wouldn’t be walking in while she and Kylie were here. Sarah stirred cream into her coffee and watched Ruby bring her cup to her lips. There was no point in sugarcoating the announcement. She might just as well spit it out. “I slept with him, Aunt Ruby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Coffee sloshed over the rim as Ruby clattered her cup back into her saucer. After a moment, she took several napkins from the chrome dispenser and mopped up the spill. “Well, I’m no expert on such things, but if that’s what you call trouble—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was three years ago,” Sarah continued quietly. “Right after that horrible mess with Vince. Jake is Kylie’s father.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Periodically checking on Kylie, she told Ruby all of it—how she’d been crying, tired of people whispering behind their hands about her, hating their pitying looks. Then how Jake had found her like that, and he’d been just as low as she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, mutual commiserating became something else,” Sarah concluded. “Now…” She smiled tightly, but with love, as she watched Kylie triple-dip a mangled French fry in the puddle of ketchup on her plate. “Now I have a precious little daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does he know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He suspects. And he deserves to know, but I’m afraid to tell him. You remember Betsy Chappell, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Moved up to Helena a while back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah nodded. “I saw her last week when I was there helping my aunt Vera after her back surgery. Betsy just lost a custody battle with her baby’s father. He was married, and when he went back to his wife, Betsy had some emotional problems. Unfortunately, the man’s a respected doctor with influential friends. Now he and his wife are raising Betsy’s son.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ruby’s sober gaze studied Kylie. “Afraid the sheriff’ll git himself a lawyer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah nodded again. “He never knew his father, and he was raised by a single mother with a gypsy life-style. After she died, he spent some time in foster homes. Aunt Ruby, this man has wanted a real family all of his life. Yes, I’m afraid he’ll get a lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“More dip-its, Mommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah rose to squirt more ketchup on Kylie’s plate, then returned to her seat. “I can’t lose her. Even joint custody would be a horror.” Tears stung her eyes, but she refused to let them fall. “He’s a stranger,” she murmured. “How can I tell him he has a daughter when I don’t know anything about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ruby chewed her lower lip for a time, then settled her gaze on Sarah’s. “First off, I don’t think you’ll lose her. But Lord knows I been wrong before. Once when I voted fer Cy Farrell, who turned out to be a low-down skunk, and once when I swore up and down I could raise watermelons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That said, I think he’s a decent sort. No fella without a conscience woulda stopped to make sure you were okay that night. Plus, he’s been here twice a day since he arrived, and I’ve watched him close. After the last fool we had wearin’ a badge in this town, I need t’ be sure this fella deserves my vote come November. If he keeps up the way he’s goin’, he’s got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So what do I do?” Sarah asked. “What would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" do?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Think on it some, I reckon. Trust that the Lord knows what He’s doin’, bringin’ Jake Russell to this town. I’m fresh out of magic wands, Sarah. If I’d had any years ago, I’da zapped that cheatin’ husband of yers clear to Jupiter. Best I kin do fer you right now is offer you a piece of apple pie and freshen that cold coffee in front of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks,” she said through a sigh. “But I—” Sarah stopped abruptly as the door opened, and Jake walked inside. To her shock and mortification, her skin began to tingle and warm, and a disconcerting airiness wafted through her stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was a light that dimmed every other man in the room—ruggedly handsome and well-built in a tan uniform that fit nearly as well as his jeans did. Removing his Stetson, he crossed to the lunch counter to speak to Jeannie Baker, the waitress who’d brought their order. Instantly, the girl’s posture was better, her smile brighter and her attention rapt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought you said the sheriff had already been here,” Sarah said nervously, irrationally bothered by Jeannie’s interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ruby turned to peek toward the front of the café. “Could be he changed his mind about dessert.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, please, don’t let it be that,")]), _vm._v(" Sarah prayed, staring into her coffee cup.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope,” Ruby continued. “He ain’t sittin’ down. Looks like he’s handin’ Jeannie one of them lunch vouchers. Must be holdin’ somebody over at the jail.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly, Sarah ventured a look. But Jake chose the same moment to scan the room, and Sarah felt her face flood with heat as their gazes met and locked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the front of the café, Jake frowned thoughtfully as Sarah jerked her gaze from his. He’d been racking his brain for two days trying to think of a way to reestablish some sort of friendship with her. He’d really screwed up, pressuring her the way he had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, as he considered his next stop, he wondered if a partial solution to his problem might be in his shirt pocket. He’d planned to ask a salesclerk for help. But talking to Sarah about something that had nothing to do with Kylie might just ease some of her insecurities where he was concerned, and pave the way to some honest conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t want to resort to demanding a paternity test.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be back in a few minutes, Jeannie,” he told the waitress. Then he walked back to Sarah’s table with a smile for all three of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Afternoon, ladies,” he said. He tried not to focus on Kylie, but it was difficult. His heart wanted to look.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sheriff,” Sarah murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My name is Jake, Sarah,” he said pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a smile that lit her whole face, Kylie scrambled to her feet in the booster chair and teetered precariously. “Hi, Jake! Want a fench fwy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrenaline shot through him. Before Jake could lunge for Kylie, Sarah sprang from her chair and sat Kylie back down. He blew out a relieved breath as she scolded her daughter softly, then shook his head at Ruby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kids,” Ruby chuckled, levering herself out of her seat. “As fer them fries, from the looks of ’em, you’d be happier with pie.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake chuckled, too. “Thanks, but I’m still full of stuffed peppers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then I’ll git you some pie to take along. Yer too skinny. Wouldn’t take a good wind long to blow you clear to Livingston.” She started away at a brisk clip. “While I’m at it, I’ll git a washcloth for our little honey-girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s okay,” Sarah called, and Jake could hear a hint of alarm in her voice. “I’ll just take her to the ladies’ room. Aunt Ruby? I think the sheriff wants to talk to you.” But Ruby was too far away to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually,” Jake said, sliding into the booth across from her and setting his hat beside him. “It’s you I want to talk to, Sarah.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60142f42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459218130_ch02.vue
// module id = 81
// module chunks = 0